import { EXERCISES } from "../types/actions";

const initialState = {
	exercisesResult: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case EXERCISES.GET_EXERCISES:
			return {
				...state,
				exercisesResult: action.payload,
				exercisesLoading: false
			};
		case EXERCISES.GET_EXERCISE_FILTERS:
			return {
				...state,
				exerciseFilters: action.payload
			};
		case EXERCISES.EXERCISE_DETAILS:
			return {
				...state,
				exerciseDetails: action.payload
			};
		case EXERCISES.SEARCH_EXERCISES:
			return {
				...state,
				exercisesSearchResult: action.payload
			};
		case EXERCISES.EXERCISE_POTENTIAL_BURN:
			return {
				...state,
				exercisesPotentialBurnData: action.payload
			};
		case EXERCISES.EXERCISE_RELATED:
			return {
				...state,
				relatedExercises: action.payload
			};
		case EXERCISES.EDIT_EXERCISE:
			return {
				...state,
				editResult: action.payload
			};
		case EXERCISES.DELETE_EXERCISES_FROM_PLAN:
			return {
				...state,
				newExerciseList: action.payload
			};

		case EXERCISES.TOGGLE_ADD_EXERCISE_PANEL:
			return {
				...state,
				showAddExercisePanel: action.payload
			};
		case EXERCISES.TOGGLE_ADD_PLAN_PANEL:
			return {
				...state,
				showAddPlanPanel: action.payload
			};

		case EXERCISES.EDIT_EXERCISE_SUMMARY:
			return {
				...state,
				editExercise: action.payload
			};
		case EXERCISES.DELETE_EXERCISE_SUMMARY:
			return {
				...state,
				exerciseHistoryResult: action.payload
			};

		default:
			return state;
	}
};
